// Screens keep time by the clock, not by counting timer ticks. ws4kp advances a screen one count per tick of an
// interval (40 ms for the scrolling lists, 9 s for most screens), so when Chrome throttles a page it thinks isn't
// seen (a covered window: wake-ups once a second, then once a minute) a 40 ms screen runs 25 times slow or worse:
// the loop sat on Hourly for good on Oct 27 and never reached a feature. Here a tick counts every interval that has
// really passed since the last one, so a throttled screen ends on time, at the next wake-up after it's due.
// Reproduced Oct 30 headless with every timer held to one second: Hourly past three minutes before, ~35 s after.
// No upstream file changes: this replaces two methods on the shared base class, as smooth-scroll.mjs does.

import WeatherDisplay from '../weatherdisplay.mjs';
import { isPlaying } from '../navigation.mjs';
import settings from '../settings.mjs';

const step = (display) => display.timing.baseDelay * (settings.speed?.value ?? 1);

const { startNavCount } = WeatherDisplay.prototype;
WeatherDisplay.prototype.startNavCount = function clockedStartNavCount() {
	if (!this.navInterval) this.navAt = performance.now();
	startNavCount.call(this);
};

WeatherDisplay.prototype.navBaseTime = function clockedNavBaseTime() {
	// paused, or not the screen on air: the count waits, and starts fresh from the next tick
	if (!isPlaying() || !this.active) {
		this.navAt = null;
		return;
	}
	const now = performance.now();
	const owed = this.navAt === null || this.navAt === undefined ? 1 : Math.max(1, Math.floor((now - this.navAt) / step(this)));
	this.navAt = this.navAt === null || this.navAt === undefined ? now : this.navAt + owed * step(this);
	this.navBaseCount += owed;
	if (this.baseCountChange) this.baseCountChange(this.navBaseCount);
	this.updateScreenFromBaseCount();
};
